{
  "dashboard": "Tableau de Bord Développeur",
  "projects": "Projets",
  "reports": "Rapports",
  "credits": "Crédits",
  "dashboard_page": {
    "title": "Tableau de Bord Développeur de Projet",
    "subtitle": "Gérez vos projets de crédits carbone et suivez les progrès de soumission",
    "stats": {
      "registered_projects": "Projets Enregistrés",
      "pending_reviews": "Révisions en Attente",
      "issued_credits": "Crédits Émis",
      "total_revenue": "Revenus Totaux"
    },
    "quick_actions": {
      "title": "Actions Rapides",
      "submit_pin": "Soumettre PIN",
      "submit_pin_desc": "Note d'Idée de Projet",
      "submit_pdd": "Soumettre PDD",
      "submit_pdd_desc": "Document de Conception de Projet",
      "upload_reports": "Télécharger Rapports",
      "upload_reports_desc": "Surveillance et Vérification",
      "browse_registry": "Parcourir Registre",
      "browse_registry_desc": "Explorer Projets",
      "request_credits": "Demander Crédits",
      "request_credits_desc": "Émission de Crédits",
      "legacy_registration": "Enregistrement Hérité",
      "legacy_registration_desc": "Dossier de Conformité",
      "view_projects": "Voir Projets",
      "view_projects_desc": "Gérer Portefeuille"
    },
    "recent_activity": {
      "title": "Activité Récente",
      "pin_submitted": "PIN soumis pour Ferme Éolienne Alpha",
      "pin_submitted_time": "il y a 2 heures",
      "pdd_approved": "PDD approuvé pour Projet Solaire Beta",
      "pdd_approved_time": "il y a 1 jour",
      "credits_issued": "Crédits émis pour Conservation Forestière Gamma",
      "credits_issued_time": "il y a 3 jours"
    },
    "project_pipeline": {
      "title": "Pipeline de Projets",
      "idea_stage": "Étape Idée",
      "design_stage": "Étape Conception",
      "validation_stage": "Étape Validation",
      "implementation_stage": "Étape Mise en Œuvre",
      "monitoring_stage": "Étape Surveillance"
    },
    "recent_projects": {
      "title": "Projets Récents",
      "view_all": "Voir Tout"
    },
    "pending_tasks": {
      "title": "Tâches en Attente",
      "urgent": "Urgent",
      "doe_selection_required": "Sélection DOE Requise",
      "doe_selection_desc": "Ferme Éolienne Alpha - Sélectionner DOE dans 5 jours",
      "monitoring_report_due": "Rapport de Surveillance Dû",
      "monitoring_report_desc": "Parc Solaire Beta - Soumission RMR requise",
      "payment_pending": "Paiement en Attente",
      "payment_pending_desc": "Frais de soumission PDD - 1 500,00 $"
    },
    "notifications": {
      "title": "Notifications Récentes",
      "pin_review_completed": "Révision PIN Terminée",
      "pin_review_desc": "Ferme Éolienne Alpha a été approuvée. Vous pouvez maintenant soumettre le PDD.",
      "doe_assignment": "Attribution DOE",
      "doe_assignment_desc": "GreenAudit Ltd assigné comme DOE pour la validation du Parc Solaire Beta.",
      "system_maintenance": "Maintenance Système",
      "system_maintenance_desc": "Maintenance programmée le 20 déc. 2024 de 2h00 à 4h00 UTC.",
      "time_2_hours_ago": "il y a 2 heures",
      "time_1_day_ago": "il y a 1 jour",
      "time_3_days_ago": "il y a 3 jours"
    }
  },
  "register_page": {
    "title": "Inscription Développeur de Projet",
    "subtitle": "Complétez votre inscription pour soumettre des projets et gérer le cycle de vie des crédits carbone",
    "form_title": "Formulaire d'Inscription",
    "form_subtitle": "Veuillez fournir des informations précises pour vérification",
    "registration_fee": "Frais d'Inscription",
    "organization_info": {
      "title": "Informations sur l'Organisation",
      "legal_name": "Nom Légal de l'Entité",
      "legal_name_placeholder": "Entrez le nom légal de votre organisation",
      "business_type": "Type d'Entreprise",
      "select_type": "Sélectionner le type d'entreprise",
      "registration_number": "Numéro d'Enregistrement",
      "registration_number_placeholder": "Numéro d'enregistrement commercial",
      "country": "Pays d'Enregistrement",
      "select_country": "Sélectionner le pays",
      "address": "Adresse Commerciale",
      "address_placeholder": "Adresse commerciale complète",
      "website": "Site Web",
      "website_placeholder": "https://www.exemple.com"
    },
    "contact_info": {
      "title": "Informations de Contact",
      "primary_contact": "Personne de Contact Principale",
      "primary_contact_placeholder": "Nom complet du contact principal",
      "job_title": "Titre du Poste",
      "job_title_placeholder": "Position dans l'organisation",
      "email": "Adresse E-mail",
      "email_placeholder": "contact{'@'}exemple.com",
      "phone": "Numéro de Téléphone",
      "phone_placeholder": "+1 (555) 123-4567",
      "alternative_contact": "Contact Alternatif",
      "alternative_contact_placeholder": "Personne de contact de secours"
    },
    "project_focus": {
      "title": "Domaines de Focus des Projets",
      "renewable_energy": "Énergie Renouvelable",
      "renewable_energy_desc": "Projets d'énergie solaire, éolienne, hydraulique",
      "energy_efficiency": "Efficacité Énergétique",
      "energy_efficiency_desc": "Efficacité des bâtiments et industrielle",
      "afolu": "AFOLU",
      "afolu_desc": "Agriculture, foresterie, utilisation des terres",
      "waste_management": "Gestion des Déchets",
      "waste_management_desc": "Traitement et élimination des déchets",
      "transport": "Transport",
      "transport_desc": "Transport durable",
      "other": "Autre",
      "other_desc": "Autres activités de réduction carbone"
    },
    "declarations": {
      "title": "Déclarations et Conformité",
      "agree_terms": "J'accepte les",
      "terms_conditions": "Termes et Conditions",
      "acknowledge_privacy": "Je reconnais la",
      "privacy_policy": "Politique de Confidentialité",
      "comply_standards": "J'accepte de me conformer aux normes et méthodologies du Registre SOR",
      "accurate_info": "Je déclare que toutes les informations fournies sont exactes et complètes",
      "legal_authority": "J'ai l'autorité légale de m'inscrire au nom de cette organisation"
    },
    "payment_info": {
      "title": "Informations de Paiement",
      "registration_fee_info": "Des frais d'inscription de 1 000,00 $ sont requis pour compléter l'inscription",
      "fee_includes": "Les frais incluent la configuration du compte, la consultation initiale du projet et le support continu",
      "payment_methods": "Méthodes de paiement acceptées : Carte de crédit, virement bancaire, cryptomonnaie"
    },
    "form_actions": {
      "submit_registration": "Soumettre Inscription (1 000,00 $)",
      "cancel": "Annuler",
      "back_to_portal": "Retour au Portail",
      "save_draft": "Enregistrer Brouillon",
      "submit_pay": "Soumettre et Payer 1 000,00 $"
    },
    "form_fields": {
      "organization_info": "Informations sur l'Organisation",
      "full_name_org": "Nom Complet / Nom de l'Organisation",
      "full_name_org_placeholder": "Entrez le nom de l'organisation",
      "business_registration_number": "Numéro d'Enregistrement d'Entreprise/Société",
      "business_registration_placeholder": "ex., ABN, EIN, Numéro de Société, Numéro TVA",
      "legal_status": "Statut Légal",
      "select_legal_status": "Sélectionner le statut légal",
      "corporation": "Société",
      "llc": "Société à Responsabilité Limitée",
      "partnership": "Partenariat",
      "non_profit": "Organisation à But Non Lucratif",
      "government_entity": "Entité Gouvernementale",
      "country_incorporation": "Pays d'Incorporation",
      "select_country": "Sélectionner le pays",
      "united_states": "États-Unis",
      "united_kingdom": "Royaume-Uni",
      "canada": "Canada",
      "germany": "Allemagne",
      "france": "France",
      "other": "Autre",
      "contact_information": "Informations de Contact",
      "physical_address": "Adresse Physique",
      "physical_address_placeholder": "Entrez l'adresse physique complète",
      "contact_email": "E-mail de Contact",
      "contact_email_placeholder": "contact{'@'}organisation.com",
      "phone_number": "Numéro de Téléphone",
      "phone_placeholder": "+1 (555) 123-4567",
      "local_representative": "Représentant Local (si entité étrangère)",
      "representative_name": "Nom du Représentant",
      "representative_name_placeholder": "Nom complet",
      "representative_email": "E-mail du Représentant",
      "representative_email_placeholder": "representant{'@'}email.com",
      "declarations_terms": "Déclarations et Conditions",
      "accuracy_declaration": "Je déclare que toutes les informations fournies sont exactes et complètes au meilleur de ma connaissance.",
      "compliance_agreement": "J'accepte de me conformer à toutes les exigences et réglementations du Registre SOR.",
      "terms_acceptance": "J'ai lu et j'accepte les",
      "terms_service": "Conditions de Service",
      "and": "et",
      "privacy_policy": "Politique de Confidentialité",
      "fee_acknowledgment": "Je reconnais les frais d'inscription de 1 000,00 $ et tous frais de maintenance applicables."
    },
    "info_boxes": {
      "what_happens_next": {
        "title": "Que se passe-t-il ensuite?",
        "review_time": "Révision de la demande sous 5-7 jours ouvrables",
        "din_generation": "Génération du Numéro d'Identification Développeur (DIN)",
        "email_verification": "Vérification par e-mail et configuration MFA",
        "portal_access": "Accès au portail de soumission de projet"
      },
      "secure_compliant": {
        "title": "Sécurisé et Conforme",
        "encryption": "Chiffrement de bout en bout pour tous les téléchargements",
        "gdpr_compliant": "Conforme RGPD et protection des données",
        "audit_trail": "Piste d'audit pour toutes les transactions",
        "security_monitoring": "Surveillance de sécurité 24/7"
      }
    }
  },
  "sidebar": {
    "dashboard": "Tableau de Bord",
    "project_ideas": "Idées de Projets",
    "design_documents": "Documents de Conception",
    "monitoring_reports": "Surveillance et Rapports",
    "credit_issuance": "Émission de Crédits",
    "browse_registry": "Parcourir Registre",
    "legacy_projects": "Projets Hérités",
    "help_support": "Aide et Support",
    "settings": "Paramètres",
    "logout": "Déconnexion"
  },
  "project": {
    "submit_pin": {
      "title": "Soumettre Note d'Idée de Projet (PIN)",
      "subtitle": "Fournir les détails initiaux du projet pour évaluation et traitement de la Lettre de Non-Objection (LNO).",
      "submission_fee": "Frais de Soumission: 500,00 $",
      "review_sla": "SLA de 30 jours pour révision",
      "auto_categorized": "Auto-catégorisé lors de la soumission",
      "developer_id": "ID Développeur",
      "save_draft": "Enregistrer comme Brouillon",
      "project_details": {
        "title": "Détails du Projet",
        "project_name": "Nom du Projet",
        "project_name_placeholder": "Entrer le nom du projet",
        "project_type": "Type de Projet",
        "select_type": "Sélectionner le type de projet",
        "project_summary": "Résumé du Projet",
        "project_summary_placeholder": "Fournir un aperçu complet du projet incluant les objectifs, la méthodologie et les résultats attendus",
        "project_scope": "Portée et Limites du Projet",
        "project_scope_placeholder": "Définir les limites physiques et temporelles du projet",
        "types": {
          "afforestation": "Afforestation/Reforestation",
          "forest_management": "Gestion Forestière",
          "renewable_energy": "Énergie Renouvelable",
          "energy_efficiency": "Efficacité Énergétique",
          "waste_management": "Gestion des Déchets",
          "agriculture": "Agriculture"
        }
      },
      "location": {
        "title": "Emplacement et Informations Géographiques",
        "country": "Pays",
        "select_country": "Sélectionner le pays",
        "state_province": "État/Province",
        "state_province_placeholder": "Entrer l'état ou la province",
        "location_description": "Description Détaillée de l'Emplacement",
        "location_description_placeholder": "Fournir des informations détaillées sur l'emplacement incluant les villes les plus proches, points de repère ou caractéristiques géographiques",
        "gps_latitude": "Coordonnées GPS (Latitude)",
        "gps_latitude_placeholder": "ex: 40.7128",
        "gps_longitude_placeholder": "ex: -74.0060",
        "gps_longitude": "Coordonnées GPS (Longitude)",
        "interactive_map": "Carte GIS interactive apparaîtra ici",
        "upload_kml": "Télécharger KML/Shapefile"
      },
      "emissions": {
        "title": "Estimations de Réduction d'Émissions",
        "annual_reduction": "Réduction Annuelle d'Émissions (tCO2e)",
        "project_duration": "Durée du Projet (années)",
        "total_reduction": "Réduction Totale Estimée (tCO2e)",
        "auto_calculated": "Auto-calculé",
        "methodology": "Méthodologie et Approche de Calcul",
        "methodology_placeholder": "Décrire la méthodologie utilisée pour les calculs de réduction d'émissions"
      },
      "uploads": {
        "title": "Téléchargements de Documents Requis",
        "npramp": "Évaluation des Risques de Non-Permanence et Plan d'Atténuation (NPRAMP)",
        "ehmf": "Formulaire de Gestion des Dommages Environnementaux (EHMF)",
        "spcp": "Plan de Consultation des Parties Prenantes et du Public (SPCP)",
        "fpic": "Consentement Libre, Préalable et Éclairé (FPIC)",
        "financial": "Proposition Financière Préliminaire",
        "required": "Requis",
        "upload_text": "Cliquer pour télécharger ou glisser-déposer",
        "file_types_doc": "PDF, DOC, DOCX jusqu'à 10MB",
        "file_types_finance": "PDF, XLS, XLSX jusqu'à 10MB"
      },
      "declarations": {
        "title": "Déclarations et Confirmations",
        "accurate_info": "Je confirme que toutes les informations fournies sont exactes et complètes selon mes connaissances.",
        "false_info_penalty": "Je comprends que la soumission d'informations fausses ou trompeuses peut entraîner un rejet et des pénalités potentielles.",
        "fee_agreement": "J'accepte les frais de soumission PIN de 500,00 $ et comprends qu'ils sont non remboursables quel que soit le résultat.",
        "review_period": "Je reconnais la période de révision de 30 jours et accepte de fournir des informations supplémentaires si demandées."
      },
      "actions": {
        "save_draft": "Enregistrer Brouillon",
        "preview": "Aperçu",
        "submission_fee_label": "Frais de Soumission:",
        "payment_processed": "Paiement traité lors de la soumission",
        "submit_pin": "Soumettre PIN"
      }
    },
    "submit_pdd": {
      "breadcrumb": {
        "dashboard": "Tableau de Bord",
        "projects": "Projets",
        "submit_pdd": "Soumettre PDD"
      },
      "title": "Soumettre Document de Conception de Projet",
      "subtitle": "Complétez votre soumission PDD avec les informations auto-remplies de votre PIN approuvé",
      "status_draft": "Brouillon",
      "project_info": {
        "title": "Informations du Projet",
        "auto_filled": "Auto-rempli depuis PIN approuvé",
        "auto_filled_description": "Les informations suivantes ont été automatiquement remplies depuis votre Note d'Idée de Projet approuvée (PIN-2024-001).",
        "project_title": "Titre du Projet",
        "project_category": "Catégorie du Projet",
        "location": "Emplacement",
        "estimated_credits": "Crédits Estimés (tCO2e)",
        "developer_id": "ID Développeur",
        "pin_reference": "Référence PIN",
        "submission_date": "Date de Soumission"
      },
      "doe_selection": {
        "title": "Entité Opérationnelle Désignée (DOE)",
        "required_message": "Sélection DOE Requise",
        "description": "Sélectionnez une DOE qualifiée pour votre secteur de projet. Le système vérifiera automatiquement les conflits d'intérêts.",
        "project_sector": "Secteur de Projet",
        "select_doe": "Sélectionner DOE *",
        "choose_doe_placeholder": "Choisir une DOE...",
        "doe_options": {
          "ecoverify": "EcoVerify International - Spécialiste Forestier",
          "carbon_audit": "Carbon Audit Solutions - Certifié AFOLU",
          "green_validation": "Green Validation Corp - Multi-Secteur",
          "forest_carbon": "Forest Carbon Assessors - Expert REDD+"
        },
        "conflict_check": {
          "title": "Vérification des Conflits d'Intérêts",
          "description": "Le système vérifiera automatiquement qu'aucun conflit n'existe entre votre organisation et la DOE sélectionnée."
        }
      },
      "documents": {
        "title": "Documents Requis",
        "positive_validation_report": {
          "title": "Rapport de Validation Positif",
          "description": "De la DOE sélectionnée"
        },
        "required_status": "Requis",
        "upload_text": "Déposez les fichiers ici ou cliquez pour parcourir",
        "choose_file": "Choisir Fichier",
        "updated_npramp": {
          "title": "NPRAMP Mis à Jour",
          "description": "Évaluation des Risques de Non-Permanence"
        },
        "auto_filled_status": "Auto-rempli",
        "updated_ehmf": {
          "title": "EHMF Mis à Jour",
          "description": "Gestion des Dommages Environnementaux"
        },
        "long_term_financial_proposal": {
          "title": "Proposition Financière à Long Terme",
          "description": "Projections financières détaillées"
        }
      },
      "actions": {
        "save_draft": "Enregistrer Brouillon",
        "preview": "Aperçu",
        "cancel": "Annuler",
        "submit_pdd": "Soumettre PDD (1 500 $)"
      },
      "sidebar": {
        "progress_card": {
          "title": "Progression de la Soumission",
          "pin_approved": {
            "title": "PIN Approuvé"
          },
          "pdd_submission": {
            "title": "Soumission PDD",
            "status": "En Cours"
          },
          "doe_validation": {
            "title": "Validation DOE",
            "status": "En Attente"
          }
        },
        "timeline_card": {
          "title": "Échéances Importantes",
          "pdd_deadline": {
            "title": "Date Limite PDD",
            "description": "18 mois à partir de la LNO"
          },
          "doe_selection": {
            "title": "Sélection DOE",
            "description": "Dans les 30 jours"
          }
        },
        "help_card": {
          "title": "Besoin d'Aide?",
          "description": "Obtenez de l'aide pour votre soumission PDD",
          "contact_support": "Contacter le Support",
          "view_guide": "Voir le Guide"
        }
      }
    }
  },
  "browse_registry": {
    "title": "Explorateur de registre",
    "subtitle": "Parcourir les projets, suivre les crédits et générer des rapports exportables",
    "export_report": "Exporter le rapport",
    "advanced_filter": "Filtre avancé",
    "search_placeholder": "Rechercher des projets...",
    "filters": {
      "all_categories": "Toutes les catégories",
      "all_status": "Tous les statuts",
      "all_proponents": "Tous les promoteurs",
      "article6_eligible": "Éligible à l'article 6",
      "clear": "Effacer"
    },
    "stats": {
      "total_projects": "Nombre total de projets",
      "credits_issued": "Crédits émis",
      "credits_retired": "Crédits retirés",
      "buffer_credits": "Crédits de réserve",
      "active_transfers": "Transferts actifs"
    },
    "projects_table": {
      "title": "Projets actifs"
    },
    "credit_tracking": {
      "recent_transactions": {
        "title": "Transactions de crédit récentes",
        "credits_issued": "Crédits émis",
        "credits_transferred": "Crédits transférés",
        "credits_retired": "Crédits retirés"
      },
      "generate_reports": {
        "title": "Générer des rapports"
      }
    }
  },
  "request_credits": {
    "title": "Émission de crédits carbone",
    "subtitle": "Gérer les demandes d'émission de crédits, les paiements de frais et les déductions obligatoires",
    "new_issuance_request": "Nouvelle demande d'émission",
    "credit_issuance_request": {
      "title": "Demande d'émission de crédit",
      "subtitle": "Soumettre les documents de vérification pour l'émission de crédit",
      "project_name": "Nom du projet",
      "select_project": "Sélectionner un projet",
      "certificate_registration": "Certificat d'enregistrement",
      "monitoring_period_start": "Début de la période de surveillance",
      "monitoring_period_end": "Fin de la période de surveillance",
      "requested_credits": "Crédits demandés pour l'émission",
      "credits_placeholder": "Entrez le nombre de crédits"
    },
    "required_documents": {
      "title": "Documents requis",
      "doe_verification": "Rapport de vérification DOE",
      "monitoring_reports": "Rapports de surveillance",
      "ics_certificates": "Certificats d'émission ICS (le cas échéant)",
      "legacy_projects_only": "Pour les projets hérités uniquement",
      "upload_pdf": "Télécharger le fichier PDF (Max 10 Mo)",
      "upload_multiple": "Télécharger plusieurs fichiers (Max 10 Mo chacun)",
      "choose_file": "Choisir le fichier",
      "choose_files": "Choisir les fichiers"
    },
    "issuance_summary": {
      "title": "Résumé de l'émission",
      "requested_credits": "Crédits demandés",
      "mandatory_deductions": {
        "title": "Déductions obligatoires",
        "ndc_retirement": "Retraite NDC (1%)",
        "buffer_account": "Compte tampon (2%)",
        "transaction_account": "Compte de transaction (30%)"
      },
      "net_credits": "Crédits nets à émettre"
    },
    "fee_calculation": {
      "title": "Calcul des frais",
      "cci_certificate_fee": "Frais de certificat CCI",
      "credit_issuance_fee": "Frais d'émission de crédit",
      "total_fee": "Frais totaux",
      "proceed_payment": "Procéder au paiement"
    },
    "processing_timeline": {
      "title": "Délai de traitement",
      "message": "L'émission de crédits prend généralement 5 à 7 jours ouvrables après la confirmation du paiement et la vérification des documents."
    },
    "recent_issuances": {
      "title": "Demandes d'émission récentes",
      "columns": {
        "request_id": "ID de la demande",
        "project": "Projet",
        "credits": "Crédits",
        "fee": "Frais",
        "status": "Statut",
        "date": "Date",
        "actions": "Actions"
      },
      "status": {
        "all": "Tous les statuts",
        "completed": "Terminé",
        "processing": "En cours de traitement",
        "pending": "En attente",
        "rejected": "Rejeté"
      }
    }
  },
  "upload_reports": {
    "breadcrumb": {
      "dashboard": "Tableau de bord",
      "project_management": "Gestion de Projet",
      "monitoring_reporting": "Surveillance et Rapport"
    },
    "title": "Télécharger les Rapports de Surveillance",
    "subtitle": "Soumettez les rapports de surveillance et de conformité requis pour vos projets approuvés",
    "project_id": "ID Projet",
    "project_name": "Conservation Forestière Beta",
    "progress": {
      "project_registered": "Projet Enregistré",
      "upload_reports": "Télécharger Rapports",
      "verification": "Vérification",
      "credit_issuance": "Émission de Crédits",
      "next_deadline": "Prochaine échéance:"
    },
    "required_documents_title": "Documents de Surveillance Requis",
    "rmr": {
      "title": "Rapport de Surveillance Régulière (RMR)",
      "description": "Soumettez des données de surveillance trimestrielles incluant les réductions d'émissions, les activités du projet et les impacts environnementaux.",
      "drop_text": "Déposez votre fichier RMR ici"
    },
    "required_documents": {
      "rmr": {
        "browse_text": "ou cliquez pour parcourir les fichiers"
      },
      "sdr": {
        "title": "Rapport de Développement Durable (SDR)",
        "description": "Documentez la contribution aux objectifs de développement durable et aux bénéfices communautaires.",
        "drop_text": "Déposez votre fichier SDR ici"
      },
      "verification": {
        "title": "Rapport de Vérification Tiers",
        "description": "Rapport de vérification indépendant par une DOE accréditée pour l'émission de crédits.",
        "drop_text": "Déposez le rapport de vérification ici"
      },
      "reversal": {
        "title": "Rapport d'Événement d'Inversion",
        "description": "Requis seulement si des inversions d'émissions se sont produites. Documentez toute augmentation non intentionnelle de GES.",
        "drop_text": "Déposez la documentation de l'événement d'inversion ici",
        "only_if_applicable": "Seulement si applicable"
      },
      "browse_files": "Parcourir Fichiers",
      "file_support": "Supporté: PDF, DOC, DOCX (Max 25MB)"
    },
    "status_labels": {
      "required": "Requis",
      "optional": "Facultatif",
      "conditional": "Conditionnel",
      "submitted": "Soumis",
      "approved": "Approuvé",
      "pending": "En Attente"
    },
    "confirmation": {
      "title": "Je confirme que tous les documents téléchargés sont exacts et complets",
      "save_draft": "Enregistrer Brouillon",
      "submit_reports": "Soumettre Rapports"
    },
    "guidelines": {
      "title": "Directives de Téléchargement",
      "english_translations": "Tous les documents doivent être en anglais ou inclure des traductions certifiées",
      "naming_convention": "Les fichiers doivent être nommés avec l'ID du projet et le type de document",
      "max_file_size": "Taille maximale de fichier: 25MB par document",
      "digital_signatures": "Signatures numériques requises pour les rapports de vérification"
    },
    "submission_status": {
      "title": "Statut de Soumission"
    },
    "help": {
      "title": "Besoin d'Aide?",
      "subtitle": "Accédez aux modèles et directives pour les rapports de surveillance",
      "rmr_template": "Modèle RMR",
      "sdr_guidelines": "Directives SDR",
      "contact_support": "Contacter le Support"
    },
    "sample_data": {
      "deadline_date": "31 Déc 2024",
      "rmr_q3_2024": "RMR T3 2024",
      "sdr_2024": "SDR 2024",
      "rmr_q4_2024": "RMR T4 2024"
    }
  },
  "legacy_registration": {
    "title": "Enregistrement de Projet Hérité",
    "subtitle": "Enregistrer des projets existants depuis d'autres normes (ICS, CDM, VCS) vers le Registre SOR",
    "standards": {
      "ics_migration": "Migration ICS",
      "cdm_transition": "Transition CDM",
      "vcs_compliance": "Conformité VCS"
    },
    "registration_form": {
      "title": "Formulaire d'Enregistrement Hérité",
      "subtitle": "Complétez tous les champs requis et téléchargez la documentation nécessaire pour l'enregistrement de projet hérité",
      "project_identification": {
        "title": "Informations du Projet",
        "project_name": "Nom du Projet*",
        "project_name_placeholder": "Entrez le nom complet du projet",
        "project_type": "Catégorie du Projet*",
        "previous_standard": "Norme Précédente*",
        "project_location": "Localisation du Projet*",
        "project_description": "Description du Projet*"
      },
      "project_details": {
        "select_category": "Sélectionner Catégorie",
        "category_1": "Catégorie 1 - Grande Échelle",
        "category_2": "Catégorie 2 - Échelle Moyenne",
        "category_3": "Catégorie 3 - Petite Échelle",
        "select_previous_standard": "Sélectionner Norme Précédente",
        "ics_standard": "ICS (Norme Carbone Internationale)",
        "cdm_standard": "CDM (Mécanisme de Développement Propre)",
        "vcs_standard": "VCS (Norme Carbone Vérifiée)",
        "other_standard": "Autre",
        "location_placeholder": "Pays, Région",
        "description_placeholder": "Fournir une description détaillée du projet"
      },
      "document_uploads": {
        "title": "Documentation Requise",
        "core_documents": "Documents de Projet Principaux",
        "compliance_documents": "Documents de Conformité",
        "pin": {
          "title": "Note d'Idée de Projet (PIN)*",
          "description": "Document de concept de projet initial"
        },
        "pdd": {
          "title": "Document de Conception de Projet (PDD)*",
          "description": "Conception de projet détaillée et méthodologie"
        },
        "doe_validation": {
          "title": "Rapport de Validation DOE*",
          "description": "Rapport de validation par un tiers"
        },
        "npramp": {
          "title": "NPRAMP*",
          "description": "Évaluation des Risques de Non-Permanence"
        },
        "ehmf": {
          "title": "EHMF*",
          "description": "Gestion des Dommages Environnementaux"
        },
        "spcp_fpic": {
          "title": "SPCP & FPIC*",
          "description": "Consultation des Parties Prenantes & FPIC"
        },
        "crediting_proof": {
          "title": "Preuve de Crédit ICS / Certificats de Norme Précédente*",
          "description": "Téléchargez la preuve de crédit précédent ou les certificats"
        },
        "financial_proposal": {
          "title": "Proposition Financière*",
          "description": "Téléchargez le document de proposition financière"
        },
        "upload_text": "Cliquez pour télécharger ou glissez-déposez",
        "file_formats": {
          "pdf_doc_10mb": "PDF, DOC (Max 10MB)",
          "pdf_doc_5mb": "PDF, DOC (Max 5MB)",
          "pdf_10mb": "PDF (Max 10MB)"
        }
      },
      "financial_info": {
        "title": "Informations Financières",
        "application_fee": "Frais de Candidature: 500,00 $",
        "fee_description": "Ces frais couvrent le processus de révision de conformité pour l'enregistrement de projet hérité."
      },
      "declarations": {
        "title": "Déclarations et Confirmations",
        "accurate_documents": "Je confirme que tous les documents téléchargés sont exacts et complets selon mes connaissances.",
        "compliance_review": "Je comprends que le projet subira une révision de conformité et pourrait nécessiter une documentation supplémentaire.",
        "fee_agreement": "J'accepte de payer les frais de candidature de 500,00 $ lors de la soumission.",
        "terms_acceptance": "J'accepte les termes et conditions du Registre SOR et les procédures de conformité."
      },
      "form_actions": {
        "save_draft": "Enregistrer Brouillon",
        "cancel": "Annuler",
        "submit_pay": "Soumettre et Payer 500,00 $"
      }
    }
  }
}